import CartWidget from "../CartWidget/CartWidget";
import { NavLink, Link } from "react-router-dom";
import logo from "../../assets/logo.jpg";
import { useState } from "react";

const NavBar = ({ user, onLogout }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md w-full">
      {/* Encabezado con título y logo */}
      <div
        className="relative flex flex-col items-center justify-center p-3 overflow-hidden"
        style={{
          backgroundImage: `url(${logo})`,
          backgroundRepeat: "repeat",
          backgroundSize: "80px 80px",
          animation: "moveBgReverse 60s linear infinite",
        }}
      >
        {/* Título */}
        <Link to="/" className="text-center">
          <h1 className="relative z-10 bg-amber-200 italic hover:not-italic font-extrabold tracking-widest hover:font-serif text-amber-500 px-4 py-2 shadow-xl shadow-rose-400 text-center text-xl md:text-2xl">
            Ortopedia Nuevo Horizonte
          </h1>
        </Link>

        {/* Carrito + Hamburguesa (solo móvil) */}
        <div className="mt-3 md:hidden flex items-center justify-center gap-4">
          <CartWidget setOpen={() => {}} />
          <button
            className="bg-amber-300 text-white p-2 rounded-md shadow-md"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>
      </div>

      {/* Menú principal */}
      <div
        className={`flex flex-col md:flex-row md:items-center md:justify-between bg-white shadow-xl transition-all duration-300 ease-in-out ${
          menuOpen ? "max-h-screen p-4" : "max-h-0 md:max-h-full md:p-4"
        } ${menuOpen ? "" : "md:overflow-visible overflow-hidden"}`}
      >
        {/* Menú izquierdo */}
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 relative">
          {user?.rol !== "jefe" && (
            <>
              {/* VENTAS con dropdown */}
              <div
                className="relative"
                onMouseEnter={() => setOpenDropdown(true)}
                onMouseLeave={() => setOpenDropdown(false)}
              >
                <NavLink
                  to="/category/ortopedia"
                  className={({ isActive }) =>
                    isActive
                      ? "text-purple-600 font-extrabold text-lg"
                      : "text-gray-700 hover:text-purple-600 font-extrabold text-lg"
                  }
                >
                  Ventas
                </NavLink>

                {/* Dropdown Desktop */}
                <div
                  className={`absolute left-0 mt-2 w-64 bg-white shadow-lg rounded-lg z-50 transition-all duration-200 ${
                    openDropdown ? "opacity-100 visible" : "opacity-0 invisible"
                  } hidden md:block`}
                >
                  <ul className="flex flex-col">
                    {[
                      ["insumos", "Insumos médicos y descartables"],
                      ["almohadas", "Línea de almohadas"],
                      ["geles", "Geles, cremas, aceites, extractos"],
                      ["neopreno", "Productos de neopreno"],
                      ["gel", "Productos de gel"],
                      ["movilidad", "Ayuda movilidad y vida diaria"],
                    ].map(([path, label]) => (
                      <NavLink
                        key={path}
                        to={`/category/ortopedia/${path}`}
                        className="px-4 py-2 hover:bg-gray-100"
                      >
                        {label}
                      </NavLink>
                    ))}
                  </ul>
                </div>

                {/* Dropdown móvil */}
                {menuOpen && (
                  <div className="md:hidden mt-2">
                    <ul className="flex flex-col space-y-1 text-sm">
                      <NavLink to="/category/ortopedia/insumos">
                        Insumos médicos y descartables
                      </NavLink>
                      <NavLink to="/category/ortopedia/almohadas">
                        Línea de almohadas
                      </NavLink>
                      <NavLink to="/category/ortopedia/geles">
                        Geles, cremas, aceites, extractos
                      </NavLink>
                      <NavLink to="/category/ortopedia/neopreno">
                        Productos de neopreno
                      </NavLink>
                      <NavLink to="/category/ortopedia/gel">
                        Productos de gel
                      </NavLink>
                      <NavLink to="/category/ortopedia/movilidad">
                        Ayuda movilidad y vida diaria
                      </NavLink>
                    </ul>
                  </div>
                )}
              </div>

              {/* ALQUILER */}
              <NavLink
                to="/category/alquiler"
                className={({ isActive }) =>
                  isActive
                    ? "text-purple-600 font-extrabold text-lg"
                    : "text-gray-700 hover:text-purple-600 font-extrabold text-lg"
                }
              >
                Alquiler
              </NavLink>
            </>
          )}
        </div>

        {/* Carrito centrado (pantallas grandes) */}
        <div className="hidden md:flex justify-center">
          <CartWidget setOpen={() => {}} />
        </div>

        {/* Usuario */}
        <div className="flex flex-col md:flex-row items-center gap-3 mt-4 md:mt-0">
          {user ? (
            <>
              <span className="text-sm text-gray-700">
                Hola, <strong>{user.email}</strong>
              </span>
              <button
                onClick={onLogout}
                className="bg-orange-400 hover:bg-red-600 text-white px-3 py-1 rounded"
              >
                Cerrar Sesión
              </button>
            </>
          ) : (
            <>
              <NavLink
                to="/"
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
              >
                Login
              </NavLink>
              <NavLink
                to="/register"
                className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded"
              >
                Register
              </NavLink>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
